module.exports = __webpack_public_path__ + "static/ABCFavoritMono-Light-8cad7611071d267b85d5512ced4be507.woff2";